import { getMfaError } from "./getMfaError";

export const getMfaErrorCode = (response) => getMfaError(response)?.errorCode;
